export default __webpack_public_path__ + "static/media/mobile_rate-partner.31639143.png";